import update from "immutability-helper";
import * as CreDtos from "../CRE.dtos";

import {
    HOMESETTINGS_REQUEST,
    HOMESETTINGS_REQUEST_SUCCESS,
    HOMESETTINGS_REQUEST_FAILURE,
    HOMESETTINGS_REQUEST_UPSERT_REQUEST,
    HOMESETTINGS_REQUEST_UPSERT_REQUEST_FAILURE,
    HOMESETTINGS_REQUEST_UPSERT_REQUEST_SUCCESS
} from "../actions/homeSettings.actions";

const initialState = {
    homeSettings: {},
    isLoading: true,
    isSaving: false
};

function loading(state, isLoading) {
    let newState = update(state, {
        isLoading: { $set: isLoading }
    });
    return newState;
}

function saving(state, isSaving) {
    let newState = update(state, {
        isSaving: { $set: isSaving }
    });
    return newState;
}

function setHomeSettings(state, homeSettings) {
    let newState = update(state, {
        homeSettings: { $set: homeSettings }
    });
    return newState;
}

export default function people(state = initialState, action) {
    switch (action.type) {
        case HOMESETTINGS_REQUEST:
            return loading(state, true);
        case HOMESETTINGS_REQUEST_SUCCESS:
            return setHomeSettings(loading(state, false), action.homeSettings);
        case HOMESETTINGS_REQUEST_FAILURE:
            return loading(state, false);
        
        case HOMESETTINGS_REQUEST_UPSERT_REQUEST:
            return saving(state, true);
        case HOMESETTINGS_REQUEST_UPSERT_REQUEST_SUCCESS:
            return saving(setHomeSettings(state, action.homeSettings), false);
        case HOMESETTINGS_REQUEST_UPSERT_REQUEST_FAILURE:
            return saving(state, false);
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/homeSettings.ts